import React, { useEffect, useRef } from 'react';

const BookingButtonWidget = () => {
  const widgetContainerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://widgets.global.bookingplatform.app/button/v1/button-widget.min.js';
    script.async = true;
    widgetContainerRef.current.appendChild(script);

    return () => {
      if (widgetContainerRef.current) {
        widgetContainerRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <div ref={widgetContainerRef} className="mt-6">
      <button-widget widget-id="2fea5a05-be3b-41f9-bd7c-d1866752abba"></button-widget>
    </div>
  );
};

export default BookingButtonWidget;